import { render, staticRenderFns } from "./TransferReport.vue?vue&type=template&id=de078c3e&scoped=true"
import script from "./TransferReport.vue?vue&type=script&lang=js"
export * from "./TransferReport.vue?vue&type=script&lang=js"
import style0 from "./TransferReport.vue?vue&type=style&index=0&id=de078c3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de078c3e",
  null
  
)

export default component.exports